export default (axiosPortal) => ({
    register: (phoneNumber) => axiosPortal.post('/auth/register', phoneNumber).then((_) => _.phoneNumber),
    login: (data) => axiosPortal.post('/auth/login', data).then((_) => _.data),
    getMe: (params) => axiosPortal.get('/auth/me', { params }).then((_) => _.params),
    confirmRegister: (data) => axiosPortal.post('/auth/confirm_register', data).then((_) => _.data),
    otpNewPass: (phoneNumber) => axiosPortal.post('/auth/forgot_password', phoneNumber).then((_) => _.phoneNumber),
    updateNewPass: (data) => axiosPortal.post('/auth/renew_password', data).then((_) => _.data),
    confirmForgotRegister: (data) => axiosPortal.post('/auth/confirm_forgot_password', data).then((_) => _.data),
});
